const empty = {
  presence: {
    allowEmpty: false,
    message: 'require'
  }
}

const Constraints = {
  airportId: empty,
  terminalId: empty,
}

const table = {
  counterNameEN: empty,
  counterNameTH: empty,
}

module.exports = {
  Constraints,
  table
}